import IAALogo from '@/assets/iaa-logo.svg'
import { Link } from '@tanstack/react-router'
import { FormattedMessage } from 'react-intl'
import { useAtomValue } from 'jotai'
import {
  selectedWorkOrderAtom,
  selectedWorkOrderIdAtom,
} from '@/state/dashboard'
import {
  initialWorkOrderIdAtom,
  loggedInEmailAtom,
} from '@/state/authentication/login'
import { activeVerificationInfo } from '@/state/verification'
import { logUserAction } from '@/services/dashboard/logUserAction'
import { UserActivityAction } from '@/types/userActivity'
import type { UserActivityLogPayload } from '@/types/userActivity'
import { TestIds } from '@/constants/testIds'

export function LegalRibbon() {
  const selectedWorkOrderId = useAtomValue(selectedWorkOrderIdAtom)
  const selectedWorkOrder = useAtomValue(selectedWorkOrderAtom)
  const initialWorkOrderId = useAtomValue(initialWorkOrderIdAtom)
  const loggedInEmail = useAtomValue(loggedInEmailAtom)
  const verificationWorkOrder = useAtomValue(activeVerificationInfo)

  const workOrderId =
    selectedWorkOrderId ??
    verificationWorkOrder?.workOrderId ??
    initialWorkOrderId ??
    undefined
  const userId =
    selectedWorkOrder?.ownerEmail ??
    verificationWorkOrder?.ownerEmail ??
    loggedInEmail ??
    undefined

  const handleTermsOfUseClick = () => {
    const activityPayload: UserActivityLogPayload = {
      WorkOrderId: workOrderId?.toString(),
      UserId: userId,
      Action: UserActivityAction.TermsOfUse,
    }
    logUserAction(activityPayload)
  }

  const handlePrivacyPolicyClick = () => {
    const activityPayload: UserActivityLogPayload = {
      WorkOrderId: workOrderId?.toString(),
      UserId: userId,
      Action: UserActivityAction.PrivacyPolicySelection,
    }
    logUserAction(activityPayload)
  }

  return (
    <div
      data-testid={TestIds.legalRibbon.container}
      className="w-full border-t border-[#a9a9a9] bg-[#e6e6e6] px-4 py-2 text-[12px] text-[#333333] shadow-sm md:px-6"
    >
      <div className="mx-auto flex max-w-screen-2xl flex-row items-start justify-between gap-4 md:flex-row md:gap-4">
        <img src={IAALogo} alt="IAA Logo" className="h-6 w-auto" />
        <div className="flex flex-col items-start gap-1 text-left md:flex-row md:flex-wrap md:items-center md:gap-2 md:text-right">
          <span>
            <FormattedMessage id="dashboard.copyRight" />
          </span>
          <span className="hidden md:inline">|</span>
          <span data-testid={TestIds.legalRibbon.termsLink}>
            <Link
              to="/terms"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2"
              onClick={handleTermsOfUseClick}
            >
              <FormattedMessage id="dashboard.termsOfUse" />
            </Link>
          </span>
          <span className="hidden md:inline">|</span>
          <span data-testid={TestIds.legalRibbon.privacyLink}>
            <Link
              to="/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2"
              onClick={handlePrivacyPolicyClick}
            >
              <FormattedMessage id="dashboard.PrivacyPolicy" />
            </Link>
          </span>
        </div>
      </div>
    </div>
  )
}
